/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
import HomePageQuery from 'Query/HomePage.query';
import OggGraphQuery from 'Query/OggGraph.query';
// import { setMaintenanceResponse } from 'Store/Maintenance/Maintenance.action';
import { updateNoMatch } from 'Store/NoMatch/NoMatch.action';
import { isSignedIn } from 'Util/Auth';
import { QueryDispatcher } from 'Util/Request';

import { updateHomePage } from './HomePage.action';
/**
 * CMS Page Dispatcher
 * @class CmsPageDispatcher
 * @extends QueryDispatcher
 * @namespace Pwa/Store/HomePage/Dispatcher/HomePageDispatcher
 */
export class HomePageDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct();
    }

    onSuccess(data = { }, dispatch) {
        const {
            slider, productSlider, content,
            newLetterPopupConfig, oggraphData = {},
            companyCustomerData, bestSellerProductsData
        } = data;

        dispatch(updateHomePage({
            slider,
            productSlider,
            content: { ...content, ...oggraphData },
            newLetterPopupConfig,
            companyCustomerData,
            bestSellerProductsData
        }, false));
    }

    onError(_, dispatch) {
        dispatch(updateNoMatch(true));
        // const MpBetterMaintenanceConfigDetails = { enabled: true, end_time: '10010' };
        // dispatch(setMaintenanceResponse({ MpBetterMaintenanceConfigDetails }));
    }

    /**
     * Prepare CMS Page query
     * @param {{url_key: String, title: Int, content: String, content_heading: String, page_layout: String, meta_title: String, meta_description: String, meta_keywords, string}} options A object containing different aspects of query, each item can be omitted
     * @return {Query} CMS Page query
     * @memberof CmsPageDispatcher
     */
    prepareRequest(options, dispatch) {
        dispatch(updateHomePage({}, true));
        const current_url = `${window.location.protocol}//${ window.location.hostname}${ window.storeConfig.baseName}`;
        if (isSignedIn()) {
            return [
                HomePageQuery.getSliderQuery(options),
                HomePageQuery.getProductSliderQuery(options),
                HomePageQuery.getContentQuery(options),
                HomePageQuery.getNewsletterPopup(options),
                HomePageQuery.getCompanyCustomerQuery(options),
                HomePageQuery.getbestSellerProductsQuery(options),
                OggGraphQuery.getQuery({ current_url, type: 'HOME' })
            ];
        }

        return [
            HomePageQuery.getSliderQuery(options),
            HomePageQuery.getProductSliderQuery(options),
            HomePageQuery.getContentQuery(options),
            HomePageQuery.getNewsletterPopup(options),
            HomePageQuery.getbestSellerProductsQuery(options),
            OggGraphQuery.getQuery({ current_url, type: 'HOME' })
        ];
    }
}

export default new HomePageDispatcher();
